import { useCartContext } from "@/context/CartContext";
import { CartTangoItem } from "@/components/cart/CartTangoItem";
import { CartTravelItem } from "@/components/cart/CartTravelItem";
import { CartZincItem } from "@/components/cart/CartZincItem";

const CartItems = () => {
  const { cart } = useCartContext();

  return (
    <div data-cypress="checkout-cart-items">
      {cart?.items?.tangoItems &&
        Object.values(cart.items.tangoItems).map((utidItems) =>
          utidItems.map((product, i) => (
            <CartTangoItem
              key={`tango-${product.utid}-${i}`}
              product={product}
              index={i}
            />
          )),
        )}

      {cart?.items?.travelItems &&
        Object.values(cart.items.travelItems).map((utidItems) =>
          utidItems.map((product, i) => (
            <CartTravelItem
              key={`travel-${product.utid}-${i}`}
              product={product}
              index={i}
            />
          )),
        )}

      {cart?.items?.zincItems &&
        Object.values(cart.items.zincItems).map((utidItems) =>
          utidItems.map((product, i) => (
            <CartZincItem
              key={`zinc-${product.utid}-${i}`}
              product={product}
              index={i}
            />
          )),
        )}
    </div>
  );
};

export default CartItems;
